import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import HeaderImage from '@/components/HeaderImage';
import LeafIcon from '@/components/LeafIcon';
import { conciergeServices } from '@/mocks/conciergerieContent';

export default function Conciergerie() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <HeaderImage />

      <main className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <h1 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-snug tracking-wide mb-8">
          Conciergerie
        </h1>

        <LeafIcon />

        {conciergeServices.map((service, i) => (
          <div key={i} className="mb-12">
            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-snug mb-4">
              {service.title}
            </h2>
            <p className="font-body text-base md:text-lg text-primary-600 font-medium mb-3">
              {service.tarif}
            </p>
            <p className="font-body font-bold text-base md:text-lg text-foreground-700 leading-normal mt-8 mb-8 whitespace-pre-line">
              {service.description}
            </p>
            <ul className="space-y-2">
              {service.items.map((item, j) => (
                <li key={j} className="flex items-start gap-2 font-body text-base md:text-lg text-foreground-800">
                  <span className="text-foreground-950 text-2xl leading-none mt-0">·</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            {service.note && (
              <p className="font-body font-bold text-base md:text-lg text-foreground-700 italic mt-4 leading-normal">
                {service.note}
              </p>
            )}
            {service.afterNote && (
              <p className="font-body text-base md:text-lg text-foreground-700 leading-relaxed mt-4 whitespace-pre-line">
                {service.afterNote}
              </p>
            )}
            <LeafIcon />
          </div>
        ))}
      </main>

      <Footer />
    </div>
  );
}